import { businessInformationState } from './businessInformation.state';
import { businessInformationActions } from './businessInformation.actions';
import { businessInformationGetters } from './businessInformation.getters';
import { businessInformationMutations } from './businessInformation.mutations';

export default {
  state: businessInformationState,
  actions: businessInformationActions,
  getters: businessInformationGetters,
  mutations: businessInformationMutations,
};
